export default {
  selectTicketType: 'Select Ticket Type',
  confirmTicketDetails: 'Confirm Ticket Details',
  payment: 'Payment',
  receiveETicket: 'Receive E-Ticket',
  exhibitionTickets: 'Exhibition Tickets',
  viewExhibitions: 'View Exhibitions',
  exhibitionDates: 'Exhibition Dates',
  viewMap: 'View Map',
  organizer: 'Organizer',
  venue: 'Venue',
  hallNumber: 'Hall Number',
  venueAddress: 'Venue Address',
  ticketType: 'Ticket Type',
  eTicket: 'E-Ticket',
  fullEventPass: 'Full Event Pass',
  singleDayTicket: 'Single-Day Ticket',
  freeAdmission: 'Free Admission',
  limitedTimeOffer: 'Limited Time Offer',
  soldOut: 'Sold Out',
  discounted: 'Discounted',
  RMB: 'RMB',
  deliveryMethod: 'Delivery Method',
  'selectCompany/individual': 'Select Company/Individual',
  company: 'Company',
  individual: 'Individual',
  visitor: 'Visitor',
  addVisitor: 'Add Visitor',
  ticketPreview: 'Ticket Preview',
  businessLicense: 'Business License',
  businessLicenseSample: 'Business License Sample',
  completeProfile: 'Complete Profile',
  fullName: 'Full Name',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  jobTitle: 'Job Title',
  mobileNumber: 'Mobile Number',
  email: 'Email',
  idType: 'ID Type',
  idNumber: 'ID Number',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  agreeSubmit: 'Agree & Submit Order',
  basicInfo: 'Basic Info',
  chineseName: 'Chinese Name',
  location: 'Location',
  abbreviation: 'Abbreviation',
  visitorCount: 'Visitor Count',
  exhibitorCount: 'Exhibitor Count',
  exhibitionIntro: 'Exhibition Introduction',
  onSitePhotos: 'On-site Photos',
  moreTickets: 'More Tickets',
  clickToBuy: 'Click to Buy',
  orderAmount: 'Order Amount',
  modifyOrder: 'Modify Order',
  alipay: 'Alipay',
  wechatPay: 'WeChat Pay',
  redirectToAlipay: "Click 'Proceed to Pay' to redirect to Alipay",
  scanWechatQR: "Click 'Proceed to Pay' to scan QR code via WeChat",
  proceedToPay: 'Proceed to Pay',
  paymentSecurity: 'Juzhan Payment Security Commitment',
  preRegistrationTickets: 'Pre-registered Tickets',
  deliveryTickets: 'Delivery Tickets',
  eInvoice: 'E-Invoice',
  notes: 'Important Notes',
  serviceFee: 'Service Fee',
  vat: 'VAT',
  promotion: 'Promotion',
  totalAmount: 'Total Amount',
  limitedTimeFree: 'Limited Time Free',
  feeInclusion: '(Includes: VAT, Service Fee)',
  imageRequirements: 'Supported formats: Images larger than 600x800 pixels, file size under 2MB',
  ticketingTerms: 'Ticketing Terms',
  ticketGuidelines:
    'After successful ticket purchase, access the website/app to display your ticket QR code. Carry the original ID used during purchase for entry verification. Final venue details are subject to on-site arrangements.',
  entryInstructions:
    'After successful ticket booking, please bring the original ID card of the visitor for swipe entry or exchange for a paper pass at the on-site service counter.',
  entryProcedure:
    'After successful ticket booking, please bring the original passport of the visitor and the e-ticket to the on-site service counter or self-service kiosk to exchange for an entry pass.',
  eventUpdatesNotice:
    'In case of exhibition postponement or cancellation, attendees will receive unified notifications via SMS and email. Updated postponement schedules will also be communicated through these channels. Stay informed! Subscribe to Juzhan Mini Program or Official Account for alerts.',
  feeCoverage:
    'Fees include ticket cost and booking service fee. Detailed breakdown available in pricing details. Services provided: ticket issuance, event postponement/cancellation notices, venue changes, and meeting reminders.',
  ticketUsagePolicy:
    'Tickets are non-transferable and valid only for the applicant. E-tickets can be exchanged for paper passes at the venue service desk.',
  ticketPurchaseNotice:
    'Please check the visit date and entry time of your e-ticket during purchase. Tickets are non-refundable, non-exchangeable, and non-transferable after sale. Keep it securely.',
  audienceScope:
    'B2B Event, Professionals Only, Application Subject to Approval, Supplementary Materials May Be Requested During Verification.',
  refundPolicy:
    'If the application is rejected or approval deadline is missed, payment will be refunded within 3 business days via original payment method.',
  privacyConsent: 'I agree to retain my personal data under this Privacy Policy',
  wechatScanPayment: "Open WeChat 'Scan' to scan the QR code for payment",
  visitorRealNameSystem: 'Real-Name Registration Required',
  bookingPurpose:
    'To reduce on-site queuing and crowding, post-booking notifications sent via SMS/WeChat/Email',
  ticketStatus: 'Tickets Sold Out',
  bookingStatus: 'Online Booking Not Yet Available',
  bookingClosed: 'Online Booking Closed',
  refundPolicy2: 'Non-refundable',
  ticketNature:
    'Tickets are securities, not general merchandise. Cultural services are time-sensitive and exclusive, Non-refundable & Non-exchangeable.',
  realNamePolicy: 'Real-Name Admission Policy',
  ticketingRule:
    'Real-Name Ticketing & Entry Required, Present original ID matching booking credentials',
  electronicTickets:
    'E-tickets: Validate entry via QR code or ID card in the ticket wallet (details in post-order ticket wallet)',
  courierTickets:
    'Courier Tickets: Paper tickets will be mailed to your provided address after issuance. Postage fees borne by the customer. Note: Courier service stops 3 days prior to the event. Tickets available at designated pickup locations (details in post-order ticket wallet).',
  invoiceTiming:
    'E-invoices are supported. Request reissue via the order page before the exhibition starts. Invoices will be uniformly provided by the organizer approximately one month after the exhibition concludes.',
  companyName: 'Company Name',
  attendeeName: 'Name',
  companyNameInput: 'Enter Company Name',
  nameInput: 'Enter Name',
  confirmButton: 'Confirm',
  cancelButton: 'Cancel',
  addAttendee: 'Add Attendee',
  genderSelection: 'Select Gender',
  positionSelection: 'Select Position',
  generalStaff: 'General Staff',
  manager: 'Manager',
  generalManager: 'General Manager',
  chairman: 'Chairman',
  phoneNumberLabel: 'Attendee Mobile (for SMS notifications)',
  emailLabel: 'Attendee Email (for notifications)',
  idTypeLabel: 'Select ID Type',
  idCard: 'ID Card',
  passport: 'Passport',
  hkMacaoPass: 'Mainland Travel Permit for Hong Kong/Macao Residents',
  taiwanPass: 'Mainland Travel Permit for Taiwan Residents',
  idNumberInput: 'Enter ID Number',
  departmentLabel: 'Department',
  marketingDept: 'Marketing Department',
  operationsDept: 'Operations Department',
  adminDept: 'Administration Department',
  procurementDept: 'Procurement Department',
  companyTypeLabel: 'Company Type (Select up to three)',
  otherOption: 'Other',
  industryServedLabel: 'Industry Served (Select up to three)',
  productInterestLabel: 'Products of Interest (Multiple Selections)',
  imageSizeLimit: 'Image files under 2MB supported',
  idFrontExample: 'ID Card Front Example',
  passportFrontExample: 'Passport Front Example',
  hkMacaoFrontExample: 'Mainland Travel Permit Front (HK/Macao)',
  taiwanFrontExample: 'Mainland Travel Permit Front (Taiwan)',
  idBackExample: 'ID Card Reverse Example',
  passportBackExample: 'Passport Reverse Example',
  hkMacaoBackExample: 'Mainland Travel Permit Reverse (HK/Macao)',
  taiwanBackExample: 'Mainland Travel Permit Reverse (Taiwan)',
  iDPhotos: 'ID photos',
  portraitRequirement: 'Images above 600*800px and under 2MB supported',
  avatarExample: 'Profile Photo Example',
  businessCardLabel: 'Business Card',
  businessCardExample: 'Business Card Example'
}
